var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_126_88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.721267 7.98515C0.770368 7.99312 0.820059 7.9968 0.869777 7.99615L9.33554 7.99615L9.15094 8.08201C8.9705 8.16741 8.80635 8.28365 8.66583 8.42545L6.29182 10.7995C5.97916 11.0979 5.92662 11.5781 6.16733 11.9371C6.44747 12.3197 6.98471 12.4027 7.36732 12.1226C7.39823 12.1 7.42761 12.0753 7.45522 12.0487L11.7482 7.75575C12.0837 7.42063 12.084 6.877 11.7489 6.54151C11.7486 6.54129 11.7484 6.54105 11.7482 6.54084L7.45522 2.24787C7.11945 1.91304 6.57583 1.91379 6.24098 2.24956C6.21463 2.27599 6.19002 2.3041 6.16733 2.33373C5.92662 2.69275 5.97916 3.17289 6.29182 3.47136L8.66154 5.84967C8.78751 5.97577 8.93235 6.08151 9.09084 6.16305L9.34841 6.27896L0.917026 6.27896C0.478418 6.26268 0.0936079 6.56906 0.0112095 7.00018C-0.0646954 7.46825 0.2532 7.90922 0.721267 7.98515Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_126_88"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "matrix(-1 0 0 -1 12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow6);
export default __webpack_public_path__ + "static/media/arrow6.2b8e8040b9867f0364d5e257ef2fe5c8.svg";
export { ForwardRef as ReactComponent };